var map = {
	"./07-dicas-para-pre-atendimento-no-mercado-imobiliario.js": [
		453,
		[
			3775
		]
	],
	"./07-fatos-importantes-que-voce-precisa-saber-antes-de-lancar-seu-empreendimento-imobiliario.js": [
		292,
		[
			966
		]
	],
	"./10-dicas-para-ter-sucesso-no-seu-marketing-imobilia.js": [
		9229,
		[
			381
		]
	],
	"./10-passos-para-se-tornar-um-corretor-de-imoveis-de-alta-performance.js": [
		5861,
		[
			7572
		]
	],
	"./10-pontos-onde-o-chatgpt-pode-colaborar-na-venda-de-imoveis.js": [
		5857,
		[
			4763
		]
	],
	"./100-frases-de-impacto-para-vender-imoveis-de-luxo.js": [
		4168,
		[
			370
		]
	],
	"./12-tendencias-de-inovacao-para-voce-ficar-atualizado.js": [
		1785,
		[
			7561
		]
	],
	"./15-desafios-na-hora-de-lancar-um-produto-imobiliario.js": [
		4806,
		[
			4752
		]
	],
	"./50-dicas-para-diferenciar-sua-imobiliaria-dos-concorrentes.js": [
		7164,
		[
			5607
		]
	],
	"./50-dicas-para-otimizar-a-abordagem-comercial-na-venda-de-imoveis.js": [
		3744,
		[
			2798
		]
	],
	"./6-aplicacoes-urgentes-de-inteligencia-artificial-para-incorporadoras-e-loteadoras.js": [
		7502,
		[
			5218
		]
	],
	"./7-tecnologias-de-interatividade-para-aplicar-no-mercado-imobiliario.js": [
		3331,
		[
			9611
		]
	],
	"./a-importancia-de-um-processo-de-vendas-estruturado.js": [
		4348,
		[
			9600
		]
	],
	"./a-importancia-do-pos-venda-no-mercado-imobiliario.js": [
		4392,
		[
			2409
		]
	],
	"./a-jornada-de-compra-de-um-imovel-100-online-com-tudo-em-um-unico-lugar.js": [
		4510,
		[
			5814
		]
	],
	"./como-a-gestao-de-vendas-com-crm-pode-impulsionar-os-resultados-da-sua-loteadora.js": [
		9784,
		[
			8623
		]
	],
	"./como-criar-seu-estande-online-de-imoveis-100-integrado-ao-seu-crm-de-vendas.js": [
		3176,
		[
			2420
		]
	],
	"./como-escolher-um-crm-de-vendas-no-mercado-imobiliario.js": [
		1013,
		[
			5229
		]
	],
	"./como-organizar-a-gestao-da-sua-loteadora.js": [
		1322,
		[
			8634
		]
	],
	"./como-otimizar-seus-resultados-utilizando-um-crm-para-incorporadoras.js": [
		9406,
		[
			7635
		]
	],
	"./como-reduzir-inadimplencia-no-loteamento.js": [
		1206,
		[
			5895
		]
	],
	"./como-sera-o-processo-de-vendas-em-2023.js": [
		6568,
		[
			1502
		]
	],
	"./como-serao-as-imobiliarias-do-futuro-10-caracteristicas-principais-2.js": [
		500,
		[
			8693
		]
	],
	"./como-vender-imoveis-e-se-destacar-no-mercado-imobiliario-passo-a-passo.js": [
		6498,
		[
			5884
		]
	],
	"./como-vender-imoveis-online-em-2023.js": [
		9271,
		[
			3075
		]
	],
	"./como-vender-lotes-encalhados.js": [
		1446,
		[
			2490
		]
	],
	"./crm-de-vendas-aplicado-a-gestao-de-incorporadoras-e-loteadoras.js": [
		6990,
		[
			9681
		]
	],
	"./erp-uau-senior-sistemas-entenda-tudo.js": [
		5407,
		[
			6872
		]
	],
	"./inteligencia-artificial-tendencia-ou-modismo.js": [
		3725,
		[
			2479
		]
	],
	"./jornada-de-venda-de-imoveis-conheca-as-etapas-e-saiba-como-otimiza-las.js": [
		3898,
		[
			9670
		]
	],
	"./marketing-para-construtoras.js": [
		4929,
		[
			8236
		]
	],
	"./mercado-imobiliario-2025-como-os-juros-altos-e-o-credito-caro-estao-redesenhando-as-vendas-e-os-lancamentos-no-brasil.js": [
		4707,
		[
			1045
		]
	],
	"./minha-casa-minha-vida-2026-o-que-muda.js": [
		1646,
		[
			3854
		]
	],
	"./o-que-a-selic-e-a-inflacao-realmente-interferem-no-mercado-imobiliario.js": [
		4555,
		[
			6663
		]
	],
	"./o-que-e-crm-imobiliario.js": [
		5439,
		[
			7640
		]
	],
	"./o-que-e-e-como-aplicar-automacao-de-marketing-e-vendas.js": [
		2834,
		[
			2033
		]
	],
	"./o-que-e-e-como-aplicar-conceitos-de-esg-na-sua-incorporadora.js": [
		4697,
		[
			4842
		]
	],
	"./o-que-e-e-quais-os-diferenciais-do-wood-frame-na-construcao-civil.js": [
		6933,
		[
			3843
		]
	],
	"./o-que-e-short-stay-e-como-funciona.js": [
		5311,
		[
			8628
		]
	],
	"./o-que-e-sistema-para-loteamento.js": [
		2094,
		[
			1437
		]
	],
	"./os-10-maiores-desafios-de-vendas-de-loteadores-no-mercado-imobiliario.js": [
		1418,
		[
			2801
		]
	],
	"./plataforma-crm-para-incorporadoras-guia-completo.js": [
		8343,
		[
			9992
		]
	],
	"./quais-sao-as-fases-de-um-lancamento-imobiliario-estrategico.js": [
		4185,
		[
			6195
		]
	],
	"./qual-a-diferenca-entre-loteadoras-e-incorporadoras.js": [
		3370,
		[
			7194
		]
	],
	"./reforma-tributaria-mercado-imobiliario-incorporadoras-loteadoras.js": [
		5313,
		[
			3397
		]
	],
	"./reforma-tributaria-ret-patrimonio-de-afetacao-incorporadoras.js": [
		6739,
		[
			9004
		]
	],
	"./software-para-loteamento-como-escolher.js": [
		6590,
		[
			9015
		]
	],
	"./split-de-comissoes-imobiliario-como-funciona.js": [
		474,
		[
			6206
		]
	],
	"./steel-frame-na-construcao-civil-brasileira-vantagens-diferenciais-desafios-e-comparacao-com-outros-metodos-construtivos.js": [
		5784,
		[
			969
		]
	],
	"./venda-de-imoveis-de-luxo-08-erros-que-voce-nao-pode-cometer.js": [
		9959,
		[
			8160
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7286;
module.exports = webpackAsyncContext;